import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useSignupStore from "../../../store/SignUpStore";
import { ChevronRight } from "lucide-react";
import "../../styles/Signup.css";

const ConsentPage = () => {
    const { setMarketingOptIn } = useSignupStore();
    const navigate = useNavigate();
    const [consents, setConsents] = useState({
        all: false,
        service: false,
        privacy: false,
        marketing: false,
    });

    const handleAllConsent = (checked) => {
        setConsents({
            all: checked,
            service: checked,
            privacy: checked,
            marketing: checked,
        });
    };

    const handleSingleConsent = (name, checked) => {
        const newConsents = { ...consents, [name]: checked };
        const allChecked = ["service", "privacy", "marketing"].every(
            (key) => newConsents[key]
        );
        setConsents({ ...newConsents, all: allChecked });
    };

    const isAllRequiredChecked = () => {
        return consents.service && consents.privacy;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isAllRequiredChecked()) {
            setMarketingOptIn(consents.marketing);
            navigate("/signup/account-info");
        } else {
            alert("필수 약관에 모두 동의해주세요.");
        }
    };

    return (
        <div className="signup-container flex flex-col items-center justify-center align-middle min-h-screen bg-white px-4 mt-[150px]">
            <div className="signup-form-container w-full max-w-md space-y-8">
                <div className="text-center">
                    <h1 className="text-2xl font-bold">이용약관 동의</h1>
                    <p className="mt-2 text-gray-600">
                        소프트캣 서비스의 이용약관에 동의해주세요
                    </p>
                </div>

                <form onSubmit={handleSubmit} className="signup-form mt-8 space-y-4">
                    <div className="space-y-4">
                        <label className="flex items-center space-x-2">
                            <input
                                type="checkbox"
                                checked={consents.all}
                                onChange={(e) =>
                                    handleAllConsent(e.target.checked)
                                }
                                className="h-4 w-4 text-blue-600 rounded"
                            />
                            <span className="font-medium">약관 전체동의</span>
                        </label>

                        <div className="space-y-2 ml-2">
                            <div className="flex items-center justify-between">
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        checked={consents.service}
                                        onChange={(e) =>
                                            handleSingleConsent(
                                                "service",
                                                e.target.checked
                                            )
                                        }
                                        className="h-4 w-4 text-blue-600 rounded"
                                    />
                                    <span>서비스 이용약관 전체동의(필수)</span>
                                </label>
                                <ChevronRight className="h-5 w-5 text-gray-400" />
                            </div>

                            <div className="flex items-center justify-between">
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        checked={consents.privacy}
                                        onChange={(e) =>
                                            handleSingleConsent(
                                                "privacy",
                                                e.target.checked
                                            )
                                        }
                                        className="h-4 w-4 text-blue-600 rounded"
                                    />
                                    <span>
                                        개인 정보 수집 및 이용 동의(필수)
                                    </span>
                                </label>
                                <ChevronRight className="h-5 w-5 text-gray-400" />
                            </div>

                            <div className="flex items-center justify-between">
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        checked={consents.marketing}
                                        onChange={(e) =>
                                            handleSingleConsent(
                                                "marketing",
                                                e.target.checked
                                            )
                                        }
                                        className="h-4 w-4 text-blue-600 rounded"
                                    />
                                    <span>마케팅 알람 수신 동의(선택)</span>
                                </label>
                                <ChevronRight className="h-5 w-5 text-gray-400" />
                            </div>
                        </div>
                    </div>

                    <button
                        type="submit"
                        style={{ marginTop: "50px" }}
                        className={`w-full h-[60px] py-3 px-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                            isAllRequiredChecked()
                                ? "bg-blue-600 text-white hover:bg-blue-700"
                                : "bg-gray-300 text-gray-500 cursor-not-allowed"
                        }`}
                    >
                        다음
                    </button>
                </form>
            </div>

            <div className="signup-logo flex justify-center mt-[250px]">
                <img
                    src="/images/softcat_new_logo.png"
                    alt=" "
                    className="w-[180px] h-[50px]"
                />
            </div>
        </div>
    );
};

export default ConsentPage;
